import {STORE_NON_ENGINEER_REQUEST, STORE_NON_ENGINEER_SUCCESS, STORE_NON_ENGINEER_FAILURE} from '../actions';
import {UPDATE_NON_ENGINEER_REQUEST, UPDATE_NON_ENGINEER_SUCCESS, UPDATE_NON_ENGINEER_FAILURE} from '../actions';
import {
    NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    NON_ENGINEER_DOCUMENT_DELETE_REQUEST,
    NON_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    NON_ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const NON_ENGINEER_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    full_name: '',
    email: '',
    phone_number: '',
    job_title: '',
    crb_expiry_date: null,
    working_at_heights: null,
    manual_handling: null,
    asbestos_cat_b: null,
    ppe: null,
    isUploading: false,
    isRemoving: false,
    uploadError: null,
    removeError: null,
    documents: []
};

const nonEngineerReducers = {
    [STORE_NON_ENGINEER_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_NON_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null, draft: false}
    },
    [STORE_NON_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_NON_ENGINEER_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_NON_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_NON_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isUploading: false, uploadError: null};
    },
    [NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [NON_ENGINEER_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [NON_ENGINEER_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);

        return {...state, documents, isRemoving: false, removeError: null}
    },
    [NON_ENGINEER_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemving: false, removeError: error};
    }
};

export default function admin(state = NON_ENGINEER_INITIAL_STATE, action) {
    let reducer = nonEngineerReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/non-engineer.js